import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW1602Model } from "./kymw1602.model";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";

@Component({
  selector: 'app-kymw1602',
  templateUrl: 'kymw1602.component.html',
  styleUrls: ['kymw1602.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1602Component extends PlessViewHelperSub implements OnInit, AfterViewInit{
  @ViewChild('goodsImage', { static: true }) goodsImage: ElementRef<HTMLImageElement>;
  @ViewChild('btn_ImageZoomClose', { static: true }) btn_ImageZoomClose: ElementRef;

  KYMW1602Model: KYMW1602Model = new KYMW1602Model();
  setKYMW1602Parameter: Function;

  constructor(
    public elementRef: ElementRef,
    private kymw00Model: KYMW00Model,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * 
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1602';
    this.KYMW1602Model.KYMW1602Component = this;
    this.btn_ImageZoomClose.nativeElement.focus();
  }

  /**
   * ビューの初期化
   * 
   */
  ngAfterViewInit(): void {
    this.setImageScale();
  }

  /**
   * 画像拡大（縦横共に500より小さい場合)
   * 
   */
  public setImageScale() {
    this.goodsImage.nativeElement.onload = () => {
      // 画像が縦横共に500より小さい場合、1.5倍に拡大する
      if ( this.goodsImage.nativeElement.naturalHeight < 500 && this.goodsImage.nativeElement.naturalWidth < 500 ) {
        this.goodsImage.nativeElement.classList.add('scaled');
      }
    }
  }

  /**
   * 親画面から値を受け取る
   * 
   */
  public inputParameterSetting(): void {
    this.KYMW1602Model = this.iInputVOArray;
  }

  public setInputVO(inputVO: KYMW1602Model): void {
    this.KYMW1602Model = inputVO;
  }
}